// Copyright 2025. WebPros International GmbH. All rights reserved.

import {
    Icon,
    Tooltip,
    Translate,
} from '@plesk/ui-library';
import styled from 'styled-components';

const Container = styled.div<{ clickable?: boolean }>`
    display: inline-flex;
    align-items: center;
    cursor: ${props => (props.clickable ? 'pointer' : 'auto')};

    span {
        margin-left: 6px;
    }
`;

interface IProps {
    value: boolean;
    onClick: () => void;
    additionalText?: string;
}

export default function DestinationComputeResourceParamStatus({
    additionalText,
    value,
    onClick,
    ...props
}: IProps) {

    const icon = value
        ? <Icon name={'check-mark-circle'} intent={'success'} />
        : <Icon name={'exclamation-mark-circle'} intent={'danger'} />;

    if (!value) {
        return (
            <Tooltip title={<Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.exclamationIconTooltip'} />}>
                <Container
                    onClick={onClick}
                    clickable={true}
                    data-cy={'clickable-container'}
                    {...props}
                >
                    {icon}

                    {!!additionalText && <span>{additionalText}</span>}
                </Container>
            </Tooltip>
        );
    }

    return (
        <Container {...props}>
            {icon}

            {!!additionalText && <span>{additionalText}</span>}
        </Container>
    );
}
